export enum ViewLoaderActionTypes {
  UpdateLoader = 'UpdateLoader',
  OpenLoader = 'OpenLoader',
  UpdateMessage = 'UpdateMessage',
  OpenWithoutText = 'OpenWithoutText',
}
